import { Icon, Text } from '@risksmart-app/atomic-ui';
import type { FC } from 'react';

import styles from './drillDownColumn.module.scss';

interface Props {
  /** How many rows the next column down will show for this card. */
  count: number;
  /** Accessible description, e.g. "Linked child obligations: 3". */
  label: string;
}

/**
 * What drilling into a card yields: the child count and a chevron.
 *
 * Render it only when the count is above zero. A card with no children carries
 * nothing, so a dead end reads as one — the absence is the information, and adding a
 * "0" would take that away.
 *
 * `body-md`, not `body-sm`: atomic-ui's scale is xs 8 / sm 10 / base 12 / lg 14px, so
 * `body-sm` renders at 10px. `body-md` is the step below the 14px card body.
 */
export const DrillCount: FC<Props> = ({ count, label }) => (
  <Text
    preset={'body-md'}
    render={<span />}
    className={styles.drillCount}
    title={label}
  >
    {count}
    <Icon name={'chevron-right'} size={'xs'} />
  </Text>
);
